import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import { VirtualizedSelect } from 'containers';
import Dialog from 'react-toolbox/lib/dialog';
import * as util from 'lib/utility';
import styles from './PopupSale.css';

const debug = _debug('app:PopupNoSale');
class PopupSale extends Component {
  static propTypes = {
    dataId: React.PropTypes.string,
    contactData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    strings: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    fetchContactData: React.PropTypes.func,
    updateContactData: React.PropTypes.func,
    closeModal: React.PropTypes.func,
    fetchDraftsData: React.PropTypes.func,
    refreshTable: React.PropTypes.func,
    currentLanguage: React.PropTypes.string,
    updateCicaDraft: React.PropTypes.func,
    fetchDraftsById: React.PropTypes.func
  };

  state = {
    label: '',
    value: '',
    valueSelected: [],
    active: false,
    optionsData: []
  }
  componentWillMount() {
    const promised = this.props.fetchDraftsData();
    promised.then((response) => {
      const optionsData = [];
      response.data.forEach((element) => {
        if (element.cica_isleadpresent === 0) {
          optionsData.push({
            name: element.policy_number,
            fullname: `${element.firstname} ${element.lastname}`
          });
        }
      });
      this.setState({ optionsData });
    }, errorResponse => debug(errorResponse));
    this.props.fetchContactData(this.props.dataId);
  }
  checkForPolicy = () => {
    if (this.state.valueSelected.length < 1) {
      this.handleToggle();
    } else {
      this.updateContactData();
    }
  }
  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }
  action = strings => [
    { label: strings.ok, onClick: this.handleToggle }
  ];
  updateContactData = () => {
    const contactData = this.props.contactData;
    contactData.cica_leaddispositionstatus = '4';
    contactData.isappointmentterminated = false;
    let soldPoliciesList = '';
    if (contactData.cica_soldpolicies != null) {
      soldPoliciesList = contactData.cica_soldpolicies;
    }
    const dataDb = this.state.valueSelected;
    const dataArray = dataDb.toString().split(',');
    dataArray.forEach((value) => {
      soldPoliciesList = soldPoliciesList ? `${soldPoliciesList},` : '';
      // CICA - 8977 - Code modified for Leads 'Sale' disposition dropdown
      // CICA - 8634 - Code modified for Leads 'Sale' disposition dropdown
      // Added toUpperCase() to avoid pushing the value again because of case sensitivity
      soldPoliciesList += value.toString().split('|')[1] ? (value.toString().split('|')[1]).trim().toUpperCase() : '';
      if ((value.toString().split('|')[1]).trim().toUpperCase() !== '') {
        this.props.fetchDraftsById((value.toString().split('|')[1]).trim().toUpperCase()).then((success) => {
          const draftData = success.data[0];
          draftData.cica_isleadpresent = 1;
          this.props.updateCicaDraft(draftData).then((result) => {
            console.log('result', result);
          }, errorResponse => debug(errorResponse));
        }, errorResponse => debug(errorResponse));
      }
    });
    contactData.cica_soldpolicies = soldPoliciesList;
    if ((contactData.cica_leadtype !== 7 && contactData.cica_leadtype !== '7')) {
      contactData.cica_isactive = 0;
    }
    this.props.updateContactData(contactData).then(() => {
      this.props.refreshTable(true);
    }, errorResponse => debug(errorResponse));
    this.props.closeModal();
  }
  updateFilter = (key, value) => {
    let valueSelected;
    const request = new Promise((resolve) => {
      valueSelected = value ? value.map(item => item.label) : [];
      this.setState({ valueSelected });
      resolve(valueSelected);
    });
    return request;
  };

  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.popupMainDiv}>
          <div className={styles.bodySubElements}>
            <span className={styles.policyHeading}>
              {strings.policyNum}*
            </span>
          </div>
          <div className={styles.questionHolder}>
            <VirtualizedSelect
              labelKey="label"
              options={util.filterPoliciesData(this.state.optionsData)}
              valueKey="value"
              type={this.state.value}
              updateFilter={this.updateFilter}
              hintText="Policy"
              filterValues={this.state.valueSelected}
              tetherToWindow={false}
              currentLanguage={this.props.currentLanguage}
            />
          </div>
          <div className={styles.addIconElement} />
        </div>
        <div className={styles.saveDiv}>
          <button
            className={styles.saveSpan}
            onClick={() => this.checkForPolicy()}
          >
            {strings.save}
          </button>
        </div>
        <Dialog
          actions={this.action(strings)}
          active={this.state.active}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          className={styles.alertDialog}
          theme={styles}
        >
          <p>{strings.pleaseSelectPolicy}</p>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contactData: state.popup.contactData,
  fetchContactData: state.popup.fetchContactData,
  updateContactData: state.popup.updateContactData,
});
export default connect(mapStateToProps, actions)(PopupSale);



// WEBPACK FOOTER //
// ./src/containers/PopupSale/PopupSale.js